import { request } from "../../../services/api"
import type { BaseApiResponse } from "../../../types/api.ts"
import type { AuditLogEntry } from "../../../types/audit-log.types.ts"
import { createFormData } from "../../../utils/form-data/create-form-data"
import type { CreateLeadParams, UpdateLeadParams } from "../redux/lead.types.ts"
import type { Lead } from "../types/lead.types.ts"

const BASE_URL = "/crm/leads"

const PATHS = {
  getLeadDetails: (id: string) => `${BASE_URL}/${id}/details/`,
  createLead: `${BASE_URL}/`,
  updateLead: (id: string) => `${BASE_URL}/${id}/details/`,
  deleteLead: (id: string) => `${BASE_URL}/${id}/`,
  getLeadLogHistory: (id: string) => `${BASE_URL}/${id}/log-history/`,
  toggleLeadFavorite: (id: string) => `${BASE_URL}/${id}/favorite/`
}

export interface LeadFavoriteToggle {
  is_favorite: boolean
}

export const getLeadDetails = (leadID: string) =>
  request.api.get<Lead, BaseApiResponse<void>>(PATHS.getLeadDetails(leadID))

export const createLead = (data: CreateLeadParams) => {
  if (!data?.file_list?.length) {
    return request.api.post<BaseApiResponse<Lead>>(PATHS.createLead, data)
  }

  const headers = { "Content-Type": "multipart/form-data" }
  const formData = createFormData(data, "file")

  return request.api.post<BaseApiResponse<Lead>>(PATHS.createLead, formData, {
    headers
  })
}

export const updateLead = ({ id, ...newInfo }: UpdateLeadParams) => {
  const url = PATHS.updateLead(id)

  if (!newInfo?.file_list?.length) {
    return request.api.patch<BaseApiResponse<Lead>>(url, newInfo)
  }

  const headers = { "Content-Type": "multipart/form-data" }
  const formData = createFormData(newInfo, "file")

  return request.api.patch<BaseApiResponse<Lead>>(url, formData, { headers })
}

export const deleteLead = (leadID: string) =>
  request.api.delete<BaseApiResponse<null>>(PATHS.deleteLead(leadID))

export const toggleLeadFavorite = (leadId: string) =>
  request.api.post<LeadFavoriteToggle, BaseApiResponse<void>>(
    PATHS.toggleLeadFavorite(leadId)
  )

export const getLeadLogHistory = (leadId: string) =>
  request.api.get<AuditLogEntry[]>(PATHS.getLeadLogHistory(leadId))
